import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonPage,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonTitle,
  IonToast,
  IonToolbar,
  isPlatform,
  useIonViewDidEnter
} from '@ionic/react';

import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { arrowBack } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  confirmarLogin,
  confirmarLoginPin,
  enviarEmail,
  enviarSms,
  requestService
} from '../../../Utils/Services';

import { MessageContext } from '../../../contexts/MessageContext';
import { authentication } from '../../../firebase-config';
import PINInput from '../../Empresa/Home/pages/Inicio/PINInput';

import './ValidarOtp.css';

const ValidarOtp: React.FC = () => {

  const history = useHistory();

  // --- Estados principais ---
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [botaoAtivo, setBotaoAtivo] = useState(true);
  const [textBotao, setTextBotao] = useState("Validar");

  const [codigo, setCodigo] = useState("");
  const [codigoValido, setCodigoValido] = useState(false);
  const [confirmation, setConfirmation] = useState<any>();

  const [desabilitarEnviarEmail, setDesabilitarEnviarEmail] = useState(false);

  const [pinCadastrado, setPinCadastrado] = useState<boolean | undefined>(undefined);

  const [pin, setPin] = useState(['', '', '', '']);
  const [erroPin, setErroPin] = useState(false);

  const { loja, setLoja } = useContext(MessageContext);

  const inputRef = useRef<any>(null);

  // Modal Esqueci o PIN
  const [showModalEsqueci, setShowModalEsqueci] = useState(false);
  const [metodoAcesso, setMetodoAcesso] = useState("email");
  // Novo: controla se está no fluxo de recuperação (após handleEnviarMetodo)
  const [recuperacaoOtp, setRecuperacaoOtp] = useState(false);


  // -----------------------------------
  // FLUXO DO PIN
  // -----------------------------------
  const prepararFluxoPin = () => {
    setPinCadastrado(true);
    setBotaoAtivo(true);
    setTextBotao("Validar PIN");
    setPin(['', '', '', '']);
    setErroPin(false);
    setDesabilitarEnviarEmail(false);
  };


  // -----------------------------------
  // FLUXO OTP / SMS
  // -----------------------------------
  const iniciarValidacaoSms = () => {
    let fcmAtivo = window.localStorage.getItem("fcmAtivo");

    if (!isPlatform('ios') && fcmAtivo === "true") {

      const nome = 'divRecaptcha' + new Date().toLocaleTimeString();
      const elementToAdd = document.createElement("div");
      elementToAdd.setAttribute('id', nome);

      const div = document.getElementById('recaptcha-container');
      if (div) div.append(elementToAdd);

      const recpVerify = new RecaptchaVerifier(
        nome,
        { 'size': 'invisible', 'callback': () => { } },
        authentication
      );

      signInWithPhoneNumber(authentication, '+' + window.localStorage.getItem("telefone"), recpVerify)
        .then((confirmationResult) => {
          setConfirmation(confirmationResult);

          setTimeout(() => {
            inputRef.current?.setFocus();
          }, 200);

          setBotaoAtivo(true);
        })
        .catch(() => {
          setTextToast("Não foi possível enviar o SMS.");
          setShowToast(true);
          history.goBack();
        });

    } else {
      setTimeout(() => {
        inputRef.current?.setFocus();
      }, 200);
      setBotaoAtivo(true);
    }
  };


  const prepararFluxoOtp = () => {
    setPinCadastrado(false);
    setTextBotao("Validar");
    setBotaoAtivo(false);
    setCodigo("");
    setCodigoValido(false);
    setErroPin(false);
    setDesabilitarEnviarEmail(false);

    const recaptchaContainer = document.getElementById('recaptcha-container');
    if (recaptchaContainer) recaptchaContainer.innerHTML = "";

    iniciarValidacaoSms();
  };


  // -----------------------------------
  // QUANDO ABRE A TELA
  // -----------------------------------
  useIonViewDidEnter(() => {
    const temPin = window.localStorage.getItem("pinCadastrado") === "true";

    setPinCadastrado(temPin);

    if (temPin) prepararFluxoPin();
    else prepararFluxoOtp();
  });


  // -----------------------------------
  // VALIDAÇÕES
  // -----------------------------------
  const validarCodigo = (valor: string): boolean => {
    const codigoNumerico = valor.replace(/\D/g, '');
    return codigoNumerico.length === 6;
  };

  const isOtpBloqueado = (error: any) => {
    const codigoErro = error?.codigo || error?.code || error?.response?.codigo;
    const mensagemErro = error?.message || error?.response?.message;

    return codigoErro === "OTP_BLOQUEADO" ||
      mensagemErro?.toLowerCase()?.includes("código bloqueado");
  };

  const getMensagemOtpBloqueado = (error: any) => {
    const mensagemErro = error?.message || error?.response?.message;
    const segundosRestantes = error?.segundosRestantes ?? error?.response?.segundosRestantes;

    if (segundosRestantes) {
      const minutosRestantes = Math.max(1, Math.ceil(segundosRestantes / 60));
      return `Código bloqueado por excesso de tentativas. Tente novamente em ${minutosRestantes} minuto${minutosRestantes > 1 ? 's' : ''}.`;
    }

    return mensagemErro || "Código bloqueado por excesso de tentativas. Tente novamente em 10 minutos.";
  };


  const validarPin = () => {
    const completo = pin.every(d => d !== "");
    if (!completo) {
      setTextToast("Por favor, preencha todos os 4 dígitos do PIN.");
      setShowToast(true);
      return;
    }

    setErroPin(false);
    setBotaoAtivo(false);
    setTextBotao("Aguarde...");
    loginComPin();
  };

  const validar = () => {
    if (pinCadastrado) {
      validarPin();
      return;
    }

    if (!codigo || !codigoValido) {
      setTextToast("Por favor, insira um código válido de 6 dígitos");
      setShowToast(true);
      return;
    }

    const codigoNumerico = codigo.replace(/\D/g, '');

    if (codigoNumerico.length !== 6) {
      setTextToast("O código deve ter exatamente 6 dígitos");
      setShowToast(true);
      return;
    }

    if (inputRef.current) inputRef.current.setBlur();

    setBotaoAtivo(false);
    setTextBotao("Aguarde...");

    let fcmAtivo = window.localStorage.getItem("fcmAtivo");

    if (!isPlatform('ios') && fcmAtivo == "true") {
      confirmation.confirm(codigo)
        .then((result: any) => {
          const user = result?.user;
          login(user?.accessToken);
        })
        .catch(() => {
          login();
        });
    } else {
      login();
    }
  };


  // -----------------------------------
  // LOGIN POR PIN
  // -----------------------------------
  function loginComPin(accessToken?: any) {
    const objectRequest = {
      pin: pin.join(''),
      accessToken,
      chaveContato: window.localStorage.getItem("chaveContato") || "0",
      telefone: window.localStorage.getItem("telefone")
    };

    requestService(
      confirmarLoginPin.url.replace("{cpf}", window.localStorage.getItem("cpf") || ""),
      {
        method: confirmarLoginPin.method,
        headers: [["token", window.localStorage.getItem("token")]],
        body: JSON.stringify(objectRequest),
        credentials: 'include'
      },
      history,
      (response: any) => {
        window.localStorage.setItem("empresa", response.gsi2pk);
        setLoja(response.gsi2pk);

        window.localStorage.setItem("logado", "true");
        if (response.lojas)
          window.localStorage.setItem("lojas", JSON.stringify(response.lojas));

        if (response.servicoPrincipal)
          window.localStorage.setItem("servicoPrincipal", response.servicoPrincipal);

        if (response.servicoTipo)
          window.localStorage.setItem("servicoTipo", response.servicoTipo);

        if (response.servicoTipoPlural)
          window.localStorage.setItem("servicoTipoPlural", response.servicoTipoPlural);

        if (response.configWorkflow)
          window.localStorage.setItem("configWorkflow", JSON.stringify(response.configWorkflow));

        if (response.nomeInternoMesaOuComanda)
          window.localStorage.setItem("nomeInternoMesaOuComanda", response.nomeInternoMesaOuComanda);

        if (response.nomeInternoMesasOuComandas)
          window.localStorage.setItem("nomeInternoMesasOuComandas", response.nomeInternoMesasOuComandas);

        if (response.nomeLinhaDoTempo)
          window.localStorage.setItem("nomeLinhaDoTempo", response.nomeLinhaDoTempo);

        if (response.polos)
          window.localStorage.setItem("polos", JSON.stringify(response.polos));

        if (response.naoAgrupar)
          window.localStorage.setItem("naoAgrupar", response.naoAgrupar);

        if (response.esconderValoresProjeto)
          window.localStorage.setItem("esconderValoresProjeto", response.esconderValoresProjeto);

        if (response.nome)
          window.localStorage.setItem("nome", response.nome);

        if (response.naoOperacao)
          window.localStorage.setItem("naoOperacao", response.naoOperacao);

        if (response.configWorkflowVenda)
          window.localStorage.setItem("configWorkflowVenda", JSON.stringify(response.configWorkflowVenda));

        if (response.empresaMarca)
          window.localStorage.setItem("empresaMarca", response.empresaMarca);

        if (response.parceria)
          window.localStorage.setItem("parceria", response.parceria);

        if (response.acessos)
          window.localStorage.setItem("acessos", JSON.stringify(response.acessos));

        if (typeof response.pinCadastrado !== 'undefined')
          window.localStorage.setItem("pinCadastrado", String(response.pinCadastrado));

        setBotaoAtivo(true);
        setPin(['', '', '', '']);
        setCodigo("");
        setCodigoValido(false);
        setTextBotao("Validar PIN");

        history.push("/empresa/inicio");
      },
      (error: any) => {
        const codigoErro = error?.codigo || error?.code || error?.response?.codigo;
        const mensagemErro = error?.message || error?.response?.message;
        const tentativasRestantes = error?.tentativasRestantes ?? error?.response?.tentativasRestantes;
        const pinBloqueado =
          codigoErro === "PIN_BLOQUEADO" ||
          mensagemErro?.toLowerCase()?.includes("bloqueado");

        if (pinBloqueado) {
          setTextToast("PIN bloqueado por excesso de tentativas. Para acessar novamente, utilize a opção \"Esqueci meu PIN\".");
        } else if (tentativasRestantes !== undefined) {
          setTextToast(`${mensagemErro || "PIN inválido"}. Tentativas restantes: ${tentativasRestantes}`);
        } else {
          setTextToast(mensagemErro || "PIN inválido");
        }
        setShowToast(true);
        setPin(['', '', '', '']);
        setErroPin(true);
        setBotaoAtivo(true);
        setTextBotao("Validar PIN");
      }
    );
  }


  // -----------------------------------
  // LOGIN POR OTP
  // -----------------------------------
  function login(accessToken?: any) {
    const codigoNumerico = codigo.replace(/\D/g, '');

    const objectRequest = {
      otp: codigoNumerico,
      accessToken,
      chaveContato: window.localStorage.getItem("chaveContato") || "0",
      telefone: window.localStorage.getItem("telefone")
    };

    requestService(
      confirmarLogin.url.replace("{cpf}", window.localStorage.getItem("cpf") || ""),
      {
        method: confirmarLogin.method,
        headers: [["token", window.localStorage.getItem("token")]],
        body: JSON.stringify(objectRequest),
        credentials: 'include'
      },
      history,
      (response: any) => {
        window.localStorage.setItem("empresa", response.gsi2pk);
        setLoja(response.gsi2pk);

        window.localStorage.setItem("logado", "true");

        if (response.lojas)
          window.localStorage.setItem("lojas", JSON.stringify(response.lojas));

        if (response.servicoPrincipal)
          window.localStorage.setItem("servicoPrincipal", response.servicoPrincipal);

        if (response.servicoTipo)
          window.localStorage.setItem("servicoTipo", response.servicoTipo);

        if (response.servicoTipoPlural)
          window.localStorage.setItem("servicoTipoPlural", response.servicoTipoPlural);

        if (response.configWorkflow)
          window.localStorage.setItem("configWorkflow", JSON.stringify(response.configWorkflow));

        if (response.nomeInternoMesaOuComanda)
          window.localStorage.setItem("nomeInternoMesaOuComanda", response.nomeInternoMesaOuComanda);

        if (response.nomeInternoMesasOuComandas)
          window.localStorage.setItem("nomeInternoMesasOuComandas", response.nomeInternoMesasOuComandas);

        if (response.nomeLinhaDoTempo)
          window.localStorage.setItem("nomeLinhaDoTempo", response.nomeLinhaDoTempo);

        if (response.polos)
          window.localStorage.setItem("polos", JSON.stringify(response.polos));

        if (response.naoAgrupar)
          window.localStorage.setItem("naoAgrupar", response.naoAgrupar);

        if (response.esconderValoresProjeto)
          window.localStorage.setItem("esconderValoresProjeto", response.esconderValoresProjeto);

        if (response.nome)
          window.localStorage.setItem("nome", response.nome);

        if (response.naoOperacao)
          window.localStorage.setItem("naoOperacao", response.naoOperacao);

        if (response.configWorkflowVenda)
          window.localStorage.setItem("configWorkflowVenda", JSON.stringify(response.configWorkflowVenda));

        if (response.empresaMarca)
          window.localStorage.setItem("empresaMarca", response.empresaMarca);

        if (response.parceria)
          window.localStorage.setItem("parceria", response.parceria);

        if (response.acessos)
          window.localStorage.setItem("acessos", JSON.stringify(response.acessos));

        if (typeof response.pinCadastrado !== 'undefined')
          window.localStorage.setItem("pinCadastrado", String(response.pinCadastrado));

        setBotaoAtivo(true);
        setCodigo("");
        setCodigoValido(false);
        setTextBotao("Validar");

        history.push("/empresa/inicio");
      },
      (error: any) => {
        const mensagemErro = error?.message || error?.response?.message;
        const tentativasRestantes = error?.tentativasRestantes ?? error?.response?.tentativasRestantes;

        if (isOtpBloqueado(error)) {
          setTextToast(getMensagemOtpBloqueado(error));
          setDesabilitarEnviarEmail(true);
          setBotaoAtivo(false);
        } else if (tentativasRestantes !== undefined) {
          setTextToast(`${mensagemErro || "Código inválido"}. Tentativas restantes: ${tentativasRestantes}`);
          setBotaoAtivo(true);
        } else {
          setTextToast(mensagemErro || "Código inválido");
          setBotaoAtivo(true);
        }
        setShowToast(true);
        setCodigo("");
        setCodigoValido(false);
        setTextBotao("Validar");
      }
    );
  }


  // -----------------------------------
  // ENVIO POR EMAIL
  // -----------------------------------
  const enviarPorEmail = () => {
    requestService(
      enviarEmail.url.replace("{cpf}", window.localStorage.getItem("cpf") || ""),
      {
        method: enviarEmail.method,
        headers: [["token", window.localStorage.getItem("token")]],
        credentials: 'include'
      },
      history,
      (response: any) => {
        setTextToast(response.message);
        setShowToast(true);
        setDesabilitarEnviarEmail(true);
      },
      (error: any) => {
        if (isOtpBloqueado(error)) {
          setTextToast(getMensagemOtpBloqueado(error));
          setDesabilitarEnviarEmail(true);
          setBotaoAtivo(false);
        } else {
          setTextToast("Ocorreu um erro ao enviar o e-mail");
        }
        setShowToast(true);
      }
    );
  };


  // -----------------------------------
  // ENVIO POR SMS (stub)
  // -----------------------------------
  const enviarPorSms = () => {
    requestService(
      enviarSms.url.replace("{cpf}", window.localStorage.getItem("cpf") || ""),
      {
        method: enviarSms.method,
        headers: [["token", window.localStorage.getItem("token")]],
        credentials: 'include'
      },
      history,
      (response: any) => {
        setTextToast(response.message || "SMS enviado com sucesso");
        setShowToast(true);
      },
      (error: any) => {
        if (isOtpBloqueado(error)) {
          setTextToast(getMensagemOtpBloqueado(error));
          setDesabilitarEnviarEmail(true);
          setBotaoAtivo(false);
        } else {
          setTextToast("Erro ao enviar SMS");
        }
        setShowToast(true);
      }
    );
  };


  // -----------------------------------
  // BOTÃO DO MODAL
  // -----------------------------------
  const handleEnviarMetodo = () => {
    setShowModalEsqueci(false);
    setRecuperacaoOtp(true); // Ativa modo recuperação
    prepararFluxoOtp();
    if (metodoAcesso === "email") enviarPorEmail();
    else enviarPorSms();
  };


  // -----------------------------------
  // INPUT DO CÓDIGO
  // -----------------------------------
  function onChangeCodigo(e: any) {
    e.persist();
    e.preventDefault();

    const valor = e.target.value;
    const codigoNumerico = valor.replace(/\D/g, '');
    const codigoLimitado = codigoNumerico.slice(0, 6);

    setCodigo(codigoLimitado);
    setCodigoValido(validarCodigo(codigoLimitado));

    if (e.keyCode === 13) {
      if (botaoAtivo && codigoLimitado.length === 6) validar();
    }
  }




  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonBackButton icon={arrowBack} text=''></IonBackButton>
          </IonButtons>
          <IonTitle>
            {pinCadastrado === undefined
              ? ""
              : pinCadastrado
                ? "DIGITE SEU PIN"
                : "VALIDE O CÓDIGO"}
          </IonTitle>
        </IonToolbar>
      </IonHeader>



      <IonContent className={"ValidarLogin"}>
        {pinCadastrado === undefined ? null : (
          <IonGrid>
            <IonRow className="ion-justify-content-center ion-margin-top">
              <IonCol size="12" sizeMd="8" sizeLg="6">
                {pinCadastrado ? (
                  <>
                    <IonLabel>
                      <h2 style={{ textAlign: "center", marginBottom: "10px" }}>
                        <strong>Digite seu PIN</strong> de 4 dígitos:
                      </h2>
                    </IonLabel>

                    <div style={{ padding: "32px" }}>
                      <PINInput
                        length={4}
                        error={erroPin}
                        idPrefix="pin-validacao-otp-input"
                        onChange={(pinDigitado: string) => {
                          const arr = pinDigitado.split("");
                          while (arr.length < 4) arr.push("");
                          setPin(arr.slice(0, 4));
                        }}
                      />
                    </div>

                    <IonButton
                      expand="block"
                      size="large"
                      disabled={!botaoAtivo}
                      onClick={() => {
                        if (!pin.every(d => d !== '')) {
                          setTextToast('Preencha todos os campos do PIN');
                          setShowToast(true);
                          return;
                        }
                        validar();
                      }}
                    >
                      {textBotao}
                    </IonButton>

                    <IonButton
                      fill="clear"
                      size="large"
                      color="tertiary"
                      onClick={() => setShowModalEsqueci(true)}
                    >
                      Esqueci meu PIN
                    </IonButton>
                  </>
                ) : (
                  <>
                    <IonLabel>
                      <h2 style={{ textAlign: "center", marginBottom: "10px" }}>
                        {recuperacaoOtp
                          ? (
                            metodoAcesso === 'email'
                              ? <>Insira o <strong>código</strong> recebido por <strong>E-mail</strong>:</>
                              : <>Insira o <strong>código</strong> recebido por <strong>SMS</strong>:</>
                          )
                          : <>Insira o <strong>código</strong> recebido por <strong>SMS</strong>:</>
                        }
                      </h2>
                    </IonLabel>

                    <div className="input" style={{ marginBottom: "20px" }}>
                      <span>Código</span>
                      <IonInput
                        ref={(ref) => (inputRef.current = ref)}
                        type="text"
                        maxlength={6}
                        required
                        value={codigo}
                        onKeyUp={onChangeCodigo}
                        onIonInput={(e: any) => setCodigo(e.target.value)}
                      />
                    </div>

                    <IonButton
                      expand="block"
                      style={{ marginTop: "20px" }}
                      disabled={!botaoAtivo}
                      onClick={() => {
                        if (!codigo || codigo.length !== 6) {
                          setTextToast('Preencha o código de 6 dígitos');
                          setShowToast(true);
                          return;
                        }
                        validar();
                      }}
                    >
                      {textBotao}
                    </IonButton>

                    {/* Só mostra o botão de enviar por e-mail se NÃO estiver no fluxo de recuperação */}
                    {!recuperacaoOtp && (
                      <IonButton
                        fill="clear"
                        color="tertiary"
                        disabled={desabilitarEnviarEmail}
                        onClick={enviarPorEmail}
                      >
                        Enviar código por e-mail
                      </IonButton>
                    )}
                  </>
                )}
              </IonCol>
            </IonRow>
          </IonGrid>
        )}

        <div id="recaptcha-container"></div>

        {/* -------------------------------
            TOAST
        -------------------------------- */}
        <IonToast
          isOpen={showToast}
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          position="middle"
          duration={3000}
        />


        {/* -------------------------------
            MODAL — ESQUECI MEU PIN
        -------------------------------- */}
        <IonModal
          isOpen={showModalEsqueci}
          onDidDismiss={() => setShowModalEsqueci(false)}
        >
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Esqueci meu PIN</IonTitle>
              <IonButtons slot="start" onClick={() => { setShowModalEsqueci(false); }}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding" >
            <IonLabel style={{ display: 'block', marginBottom: 16, marginTop: 8 }}>
              Como deseja acessar?
            </IonLabel>
            <IonRadioGroup
              value={metodoAcesso}
              onIonChange={e => setMetodoAcesso(e.detail.value)}
            >
              <IonItem lines="none">
                <IonRadio slot="start" value="email" />
                <IonLabel>E-mail</IonLabel>
              </IonItem>
              <IonItem lines="none">
                <IonRadio slot="start" value="sms" />
                <IonLabel>SMS</IonLabel>
              </IonItem>
            </IonRadioGroup>

            <IonButton
              expand="block"
              size="large"
              style={{ marginTop: 24 }}
              onClick={handleEnviarMetodo}
            >
              Avançar
            </IonButton>

          </IonContent>
        </IonModal>

      </IonContent>
    </IonPage>
  );
};

export default ValidarOtp;
